import { useTranslation } from 'react-i18next'

import {
  BuildingGroupMultiSelect,
  BuildingGroupSelectFormikField,
} from '../../../../../../../BuildingGroup'
import { FieldStackedLabel } from '../../../../../../../Field'
import { NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP } from '../../../RecipientsField.constants'

function BuildingGroupFields({ disabled }) {
  const { t } = useTranslation()

  return (
    <>
      <BuildingGroupSelectFormikField
        multi
        Field={FieldStackedLabel}
        Select={BuildingGroupMultiSelect}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t(
                'Newsboard.RecipientsBuildingGroupsPlaceholderKey'
              ),
            },
          },
        }}
        disabled={disabled}
        fieldComponentProps={{
          disabled,
          label: t('Newsboard.RecipientsBuildingGroupsLabelKey'),
        }}
        name={NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_BUILDING_GROUP}
      />
    </>
  )
}

export default BuildingGroupFields
